module.exports = __webpack_public_path__ + "03_glasses_brown.a09d2491.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/03_glasses_brown.png
// module id = gT4v
// module chunks = 0